<template>
  <div>
    <vue-headful
        :title="$t('pages.work') + ' - Fernando Mata'"
      />
      <div id="experiencesContainer" v-for="experience in experiences" :key="experience.name">
        <article class="post">
          <CompanyCard :experience="experience" />
        </article>
      </div>
  </div>
</template>

<script>
import CompanyCard from '../components/CompanyCard.vue'
import { Trans } from '../localization/Translation.js'
import Experiences from '../data/Experience.json'

export default {
  computed: {
    experiences() {
      return Experiences[Trans.currentLanguage].sort(function (a,b) {
      Date(a.joinedAt) < Date(b.joinedAt)
      })
    }
  },
  name: "Experience",
  components: {
    CompanyCard
  }
}
</script>

<style scoped>
.post {
  padding: 1em 3em 1em 3em;
}
</style>
